// Generador ULID mínimo (Crockford base32). No agregamos dependencia: el outbox
// necesita ids ordenables por tiempo + únicos para dedupe e idempotencia del backend.
// Formato: 10 chars de timestamp (ms) + 16 chars de aleatoriedad = 26 chars.

const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford, sin I L O U
const ENCODING_LEN = ENCODING.length;
const TIME_LEN = 10;
const RANDOM_LEN = 16;

function encodeTime(now: number): string {
  let out = '';
  let mod = now;
  for (let i = TIME_LEN - 1; i >= 0; i--) {
    const rem = mod % ENCODING_LEN;
    out = ENCODING[rem] + out;
    mod = (mod - rem) / ENCODING_LEN;
  }
  return out;
}

function randomByte(): number {
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const buf = new Uint8Array(1);
    crypto.getRandomValues(buf);
    return buf[0];
  }
  return Math.floor(Math.random() * 256);
}

function encodeRandom(): string {
  let out = '';
  for (let i = 0; i < RANDOM_LEN; i++) {
    out += ENCODING[randomByte() % ENCODING_LEN];
  }
  return out;
}

// Genera un ULID de 26 chars. Monótono-suficiente para nuestro uso (orden por ms).
export function ulid(now: number = Date.now()): string {
  return encodeTime(now) + encodeRandom();
}

export default ulid;
